import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: _normalizeClass(["item", { active: $props.active === 'day' }]),
      to: `/report/day/${$props.equipmentId}`
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("dateType.day")), 1)
      ]),
      _: 1
    }, 8, ["class", "to"]),
    (!$setup.openId)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: _normalizeClass(["item", { active: $props.active === 'month' }]),
          to: `/report/month/${$props.equipmentId}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("dateType.month")), 1)
          ]),
          _: 1
        }, 8, ["class", "to"]))
      : _createCommentVNode("", true)
  ]))
}